import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

type Props = PropsWithChildren<{
  className?: string;
  error?: boolean;
}>;

export function FormHelpText({ children, className, error }: Props): React.ReactElement {
  const classNames = twMerge('mt-1 text-xs', error ? 'text-red-500' : 'text-gray-500', className);

  return <small className={classNames}>{children}</small>;
}
